module.exports = __webpack_public_path__ + "static/img/1393_phase_function_Paper_PointsHejduk_Prediction.371d69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1393_phase_function_Paper_PointsHejduk_Prediction.png
// module id = n/N6
// module chunks = 0